/**
 * en-GB messages added by Phase 3 task W19 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * `p3pt.*` is permits to work; `p3lw.*` is lone working.
 */
export const w19EnGB = {
    // ---------- Permits: shared words ----------
    'p3pt.status.requested': 'Requested',
    'p3pt.status.issued': 'Issued',
    'p3pt.status.active': 'Active',
    'p3pt.status.suspended': 'Suspended',
    'p3pt.status.closed': 'Closed',
    'p3pt.status.cancelled': 'Cancelled',
    'p3pt.status.expired': 'Expired',
    'p3pt.role.issuer': 'Issuer',
    'p3pt.role.contractor': 'Contractor',
    'p3pt.role.fire_watch': 'Fire watch',
    'p3pt.role.area_owner': 'Area owner',
    'p3pt.role.isolator': 'Isolator',
    'p3pt.stage.issue': 'Issued',
    'p3pt.stage.accept': 'Accepted',
    'p3pt.stage.close': 'Closed',
    'p3pt.stage.suspend': 'Suspended',
    'p3pt.stage.resume': 'Resumed',
    'p3pt.event.raised': 'Raised',
    'p3pt.event.issued': 'Issued',
    'p3pt.event.accepted': 'Accepted by the holder',
    'p3pt.event.suspended': 'Suspended',
    'p3pt.event.resumed': 'Resumed',
    'p3pt.event.closed': 'Closed',
    'p3pt.event.cancelled': 'Cancelled',
    'p3pt.event.expired': 'Expired',
    'p3pt.event.alert': 'Alert sent',
    'p3pt.field.type': 'Permit type',
    'p3pt.field.site': 'Site',
    'p3pt.field.holder': 'Permit holder',
    'p3pt.field.company': 'Company',
    'p3pt.field.area': 'Work area',
    'p3pt.field.description': 'Description of the work',
    'p3pt.field.conditions': 'Conditions',
    'p3pt.field.precautions': 'Precautions',
    // ---------- Permits: list ----------
    'p3pt.list.title': 'Permits to work',
    'p3pt.list.description': 'Permission to carry out higher-risk work, signed by the issuer and the holder.',
    'p3pt.list.raise': 'Raise a permit',
    'p3pt.list.types': 'Permit types',
    'p3pt.filter.status': 'Status',
    'p3pt.filter.open': 'Open',
    'p3pt.filter.closed': 'Closed',
    'p3pt.filter.all': 'All',
    'p3pt.filter.anySite': 'All sites',
    'p3pt.filter.anyType': 'All types',
    'p3pt.col.number': 'Number',
    'p3pt.col.ends': 'Ends',
    // ---------- Permits: raise ----------
    'p3pt.raise.title': 'Raise a permit',
    'p3pt.raise.submit': 'Raise permit',
    'p3pt.raise.noTypes': 'There are no active permit types yet. Add one first.',
    'p3pt.raise.done': 'Permit {number} raised.',
    // ---------- Permits: one permit ----------
    'p3pt.detail.back': 'All permits',
    'p3pt.detail.pdf': 'Open PDF',
    'p3pt.detail.sha': 'PDF fingerprint (SHA-256): {sha}',
    'p3pt.detail.details': 'Details',
    'p3pt.detail.requestedBy': 'Requested by',
    'p3pt.detail.issuedBy': 'Issued by',
    'p3pt.detail.starts': 'Starts',
    'p3pt.detail.suspendedWhy': 'This permit is suspended: {reason}',
    'p3pt.detail.checklist': 'Checklist',
    'p3pt.detail.ticked': ' (ticked)',
    'p3pt.detail.notTicked': ' (not ticked)',
    'p3pt.detail.signatures': 'Signatures',
    'p3pt.detail.noSignatures': 'Nobody has signed this permit yet.',
    'p3pt.detail.events': 'History',
    'p3pt.detail.noEvents': 'No history yet.',
    'p3pt.signoff.name': '{role}: printed name',
    'p3pt.signoff.pad': '{role}: signature',
    // ---------- Permits: actions ----------
    'p3pt.act.title': 'Actions',
    'p3pt.act.cancel': 'Cancel permit',
    'p3pt.act.cancelled': 'Permit cancelled.',
    'p3pt.act.suspend': 'Suspend',
    'p3pt.act.suspendConfirm': 'Suspend permit',
    'p3pt.act.suspended': 'Permit suspended.',
    'p3pt.act.reason': 'Reason for suspending',
    'p3pt.act.resume': 'Resume',
    'p3pt.act.resumed': 'Permit resumed.',
    'p3pt.act.issued': 'Permit issued.',
    'p3pt.act.closed': 'Permit closed.',
    'p3pt.issue.title': 'Issue this permit',
    'p3pt.issue.description': 'Tick the checklist, set the times, then the issuer and the holder sign here.',
    'p3pt.issue.required': '(required)',
    'p3pt.issue.submit': 'Issue permit',
    'p3pt.close.title': 'Close this permit',
    'p3pt.close.description': 'The work is finished and the area is safe. The issuer and the holder sign to close.',
    'p3pt.close.held': 'The holder has already signed to close this permit on the app. The issuer signs to finish.',
    'p3pt.close.notes': 'Closing notes',
    'p3pt.close.submit': 'Close permit',
    // ---------- Permits: types ----------
    'p3pt.types.title': 'Permit types',
    'p3pt.types.description': 'Each type has its own checklist, sign-offs and longest duration.',
    'p3pt.types.add': 'Add a permit type',
    'p3pt.types.edit': 'Edit permit type',
    'p3pt.types.empty': 'No permit types yet.',
    'p3pt.types.name': 'Name',
    'p3pt.types.maxHours': 'Longest duration (hours)',
    'p3pt.types.maxHoursHint': 'A permit cannot be issued for longer than this (1 to 336).',
    'p3pt.types.items': 'Checklist items',
    'p3pt.types.active': 'In use',
    'p3pt.types.inactive': 'Switched off',
    'p3pt.types.noItems': 'No checklist items yet.',
    'p3pt.types.itemText': 'Checklist item {n}',
    'p3pt.types.itemRequired': 'Must be ticked to issue',
    'p3pt.types.moveUp': 'Move item {n} up',
    'p3pt.types.moveDown': 'Move item {n} down',
    'p3pt.types.removeItem': 'Remove item {n}',
    'p3pt.types.addItem': 'Add a checklist item',
    'p3pt.types.itemsMax': 'A type can have at most 50 checklist items.',
    'p3pt.types.issueSignOffs': 'Who signs to issue',
    'p3pt.types.closeSignOffs': 'Who signs to close',
    'p3pt.types.activeLabel': 'In use',
    'p3pt.types.activeHint': 'Switch off to stop new permits of this type. Existing permits are not changed.',
    'p3pt.types.saved': 'Permit type saved.',
    // ---------- Lone working: board ----------
    'p3lw.state.ok': 'OK',
    'p3lw.state.prompted': 'Asked to check in',
    'p3lw.state.second_prompt': 'Second reminder sent',
    'p3lw.state.escalated': 'Contacts told',
    'p3lw.state.panic': 'Panic',
    'p3lw.state.ended': 'Ended',
    'p3lw.reason.missed_check_in': 'Missed check-in',
    'p3lw.reason.panic': 'Panic button',
    'p3lw.board.title': 'Lone working',
    'p3lw.board.description': 'People working alone, their check-ins, and any alert that needs a response.',
    'p3lw.board.report': 'Report',
    'p3lw.board.delayed.title': 'Monitoring delayed',
    'p3lw.board.delayed.body': 'The check-in monitor has not run recently. Missed check-ins may not be noticed on time. Tell your administrator now and check on people directly.',
    'p3lw.board.stale': 'This board could not refresh. It shows what was true at {at}. Check on people directly.',
    'p3lw.board.offline': 'Live updates are not connected. The board is refreshing every few seconds instead.',
    'p3lw.board.live': 'Live: this board updates as things happen.',
    'p3lw.esc.title': 'Alerts',
    'p3lw.esc.none': 'No open alerts.',
    'p3lw.esc.recent': 'Recent alerts',
    'p3lw.esc.map': 'Where the panic alerts were raised',
    'p3lw.esc.started': 'started {at}',
    'p3lw.esc.repeats': 'repeated {n} times',
    'p3lw.esc.notAcked': 'Nobody has responded',
    'p3lw.esc.ackedBy': 'Acknowledged by {who}, {at}',
    'p3lw.esc.delay': 'This alert was raised about {minutes} minutes late because monitoring was delayed.',
    'p3lw.esc.failures': 'Warning: {n} urgent messages could not be delivered to the contacts. Phone this person and their contacts yourself.',
    'p3lw.esc.location': 'Position at the moment of the alert: {lat}, {lng} (within {accuracy} metres).',
    'p3lw.esc.openMap': 'Open on a map',
    'p3lw.esc.cleared': 'The person checked in at {at}. An all-clear was sent.',
    'p3lw.esc.resolved': 'Resolved {at}.',
    'p3lw.esc.ack': 'Acknowledge',
    'p3lw.esc.resolve': 'Resolve',
    'p3lw.esc.resolution': 'What happened',
    'p3lw.esc.resolutionHint': 'This is kept in the record.',
    'p3lw.esc.resolveConfirm': 'Mark resolved',
    'p3lw.sessions.title': 'People being watched',
    'p3lw.sessions.none': 'Nobody is lone working at the moment.',
    'p3lw.sessions.person': 'Person',
    'p3lw.sessions.site': 'Site',
    'p3lw.sessions.state': 'State',
    'p3lw.sessions.last': 'Last check-in',
    'p3lw.sessions.next': 'Next due',
    'p3lw.sessions.until': 'Planned end',
    'p3lw.sessions.never': 'None yet',
    'p3lw.sessions.overdue': 'Overdue',
    'p3lw.sessions.noContacts': 'No contacts',
    'p3lw.sessions.end': 'End session',
    'p3lw.sessions.endConfirm': 'End their session',
    // ---------- Lone working: contacts tab ----------
    'p3lw.contacts.title': 'Lone working contacts',
    'p3lw.contacts.description': 'Told by text, email and the app if this person does not check in. Up to five.',
    'p3lw.contacts.legend': 'Contacts',
    'p3lw.contacts.none': 'No contacts. The group fallback contacts, or reception, will be used.',
    'p3lw.contacts.name': 'Contact {n}: name',
    'p3lw.contacts.phone': 'Contact {n}: phone',
    'p3lw.contacts.email': 'Contact {n}: email',
    'p3lw.contacts.add': 'Add a contact',
    'p3lw.contacts.remove': 'Remove contact {n}',
    'p3lw.contacts.saved': 'Contacts saved.',
    'p3lw.contacts.nameNeeded': 'Enter a name.',
    'p3lw.contacts.reachNeeded': 'Enter a phone number or an email address.',
    'p3lw.contacts.phoneBad': 'That phone number does not look right.',
    'p3lw.contacts.emailBad': 'That email address does not look right.',
    // ---------- Lone working: settings cards ----------
    'p3lw.settings.between': 'Enter a whole number from {min} to {max}.',
    'p3lw.settings.groupTitle': 'Lone working',
    'p3lw.settings.groupDescription': 'Check-ins for people in this group who work alone.',
    'p3lw.settings.enabled': 'Check people in this group while they lone work',
    'p3lw.settings.enabledHint': 'Starts when they sign in at a remote site, or a site with lone working on.',
    'p3lw.settings.promptsOff': 'Another system already prompts these people',
    'p3lw.settings.promptsOffHint': 'No check-in sessions are made for this group.',
    'p3lw.settings.interval': 'Check in every (minutes)',
    'p3lw.settings.intervalHint': '10 to 720.',
    'p3lw.settings.grace': 'First grace (minutes)',
    'p3lw.settings.graceHint': 'Time to answer the first reminder.',
    'p3lw.settings.secondGrace': 'Second grace (minutes)',
    'p3lw.settings.secondGraceHint': 'Time to answer the second reminder before contacts are told.',
    'p3lw.settings.manualStart': 'Let people start lone working themselves',
    'p3lw.settings.membersEdit': 'Let people edit their own contacts',
    'p3lw.settings.membersEditHint': 'On the app.',
    'p3lw.settings.shareLocation': 'Share location on every check-in',
    'p3lw.settings.shareLocationHint': 'Off: position is recorded only when the panic button is used.',
    'p3lw.settings.fallback': 'Fallback contacts',
    'p3lw.settings.fallbackHint': 'Used when a person has no contacts of their own.',
    'p3lw.settings.siteTitle': 'Lone working at this site',
    'p3lw.settings.siteDescription': 'Applies to groups that have lone working switched on.',
    'p3lw.settings.siteEnabled': 'Everyone signed in here is lone working',
    'p3lw.settings.siteEnabledHint': 'Remote sites are always included.',
    // ---------- Lone working: report ----------
    'p3lw.report.title': 'Lone working report',
    'p3lw.report.description': 'Each lone-working session with its check-ins, alerts and response times.',
    'p3lw.report.back': 'Back to the board',
    'p3lw.report.range': 'Dates',
    'p3lw.report.started': 'Started',
    'p3lw.report.ended': 'Ended',
    'p3lw.report.stillOn': 'Still on',
    'p3lw.report.checkIns': 'Check-ins',
    'p3lw.report.missed': 'Missed',
    'p3lw.report.escalations': 'Alerts',
    'p3lw.report.panics': 'Panics',
    'p3lw.report.slowest': 'Slowest response',
    'p3lw.report.underMinute': 'Under a minute',
    'p3lw.report.minutes': '{n} min',
    'p3lw.report.hours': '{h} h {n} min',
};
//# sourceMappingURL=w19.js.map